import { observer } from 'mobx-react';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { crossSellingModalStore } from '../../store';
import { emptyArray } from 'src/utils/helpers';
import Crumbs, { CrumbsType } from '~/view/components/Controls/Crumbs';

const CrossSellingModalCategories: FC = observer((): JSX.Element => {
  const { loading, categories, activeCategory, categoryCrumbs, selectCategory } = crossSellingModalStore;

  if (loading && !categories.length) {
    return (
      <>
        {emptyArray().map((_, index) => (
          <Skeleton key={'key-' + String(index)} width={85} height={39} style={{ borderRadius: 10 }} className="mr-3 mt-3" />
        ))}
      </>
    );
  }

  return (
    <Crumbs type={CrumbsType.TAB} crumbs={categoryCrumbs} activeCrumb={activeCategory?.id || 0} onClick={selectCategory} crumbClassName="mt-3" />
  );
});

export default CrossSellingModalCategories;
